module.exports = __webpack_public_path__ + "img/favicon.1fa916ac.png";